/** Shell.jsx - the paper sheet the whole page is printed on. */
import { CSS, FONT, INK, MAX_W, PAGE_OPENED, PAPER, SHEET_EDGE, SURROUND } from './theme';
import { fmtStamp } from './helpers';
import { Footer } from './Notices';

export function Shell({ children }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: SURROUND,
        fontFamily: FONT,
        color: INK,
        boxSizing: 'border-box',
        padding: '26px 12px 34px',
        overflowX: 'hidden',
        WebkitFontSmoothing: 'antialiased',
        WebkitTextSizeAdjust: '100%',
      }}
    >
      <style>{CSS}</style>
      <div
        className="svm-sheet"
        style={{
          maxWidth: MAX_W,
          margin: '0 auto',
          background: PAPER,
          border: '1px solid ' + SHEET_EDGE,
        }}
      >
        {children}
        <Footer stamp={fmtStamp(PAGE_OPENED)} />
      </div>
    </div>
  );
}

/* ----------------------------------- view ------------------------------------ */
